import { Component } from '@angular/core';
import { TradeInSelectors } from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.selectors';
import { IconNames } from '@app/shared/enums/icon-names';
import { select } from '@ngxs/store';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-trade-in-mobile-phone-details',
  templateUrl: './trade-in-mobile-phone-details.component.html',
  styleUrl: './trade-in-mobile-phone-details.component.scss',
  imports: [NgClass, MatIcon],
})
export class TradeInMobilePhoneDetailsComponent {
  deviceModel = select(TradeInSelectors.deviceModel);
  previouslyValidatedImei = select(TradeInSelectors.previouslyValidatedImei);
  selectedStorageCapacity = select(TradeInSelectors.selectedStorageCapacity);

  IconNames = IconNames;
}
